import { createUnknownComponentVNode as _$cc, className as _$cn } from 'intact-vue-next';
import { Transition } from 'intact-vue-next';
import { DropdownItem } from '../dropdown';
import { isNullOrUndefined } from 'intact-shared';
import { isEmptyChildren } from '../utils';
import { Icon } from '../icon';
import { Checkbox } from '../checkbox';
import { context } from './useSearchable';
export default function ($props, $blocks, $__proto__) {
  var _classNameObj,
    _this = this;
  $blocks || ($blocks = {});
  $props || ($props = {});
  var $this = this;
  var _this$get = this.get(),
    children = _this$get.children,
    className = _this$get.className,
    disabled = _this$get.disabled,
    label = _this$get.label;
  var _this$select$get = this.select.get(),
    multiple = _this$select$get.multiple,
    searchable = _this$select$get.searchable;
  var k = this.config.k;
  var isActive = this.isActive();
  var classNameObj = (_classNameObj = {}, _classNameObj[k + "-select-option"] = true, _classNameObj[className] = className, _classNameObj[k + "-active"] = isActive, _classNameObj);
  var _children = isEmptyChildren(children) ? label : children;
  if (searchable && multiple) {
    var Consumer = context.Consumer;
    var _children2 = _children;
    _children = _$cc(Consumer, {
      'children': function children(value) {
        return _$cc(Checkbox, {
          'value': value.value,
          'ev-$change:value': value.set,
          'trueValue': _this.get('value'),
          'disabled': disabled,
          'children': _children2
        });
      }
    });
  }
  return _$cc(DropdownItem, {
    'className': _$cn(classNameObj),
    'ev-select': searchable && multiple ? null : this.onSelect,
    'disabled': disabled,
    'hideOnSelect': !multiple,
    'children': [_children, !searchable ? _$cc(Transition, {
      'name': 'k-scale',
      'children': multiple && isActive ? _$cc(Icon, {
        'className': _$cn(k + "-select-checkmark ion-ios-checkmark-empty"),
        'color': 'primary'
      }) : undefined
    }) : undefined]
  });
}
;